import { render, staticRenderFns } from "./ProductRows.vue?vue&type=template&id=02408362"
import script from "./ProductRows.vue?vue&type=script&lang=js"
export * from "./ProductRows.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports